type Props = {
  count: number
}
export const ItemCounter: React.FC<Props> = ({ count }) => (
  <div className="flex items-center font-bold leading-[1.2] xl:text-[15px]">
    <span className="text-[10px] xl:text-[14px]">投稿・アイテム数：</span>
    {count}
  </div>
)
